import { type ModalRegistration } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { SectionFormModal } from '../components/SectionFormModal/SectionFormModal';
import { SectionVisibilityDefaultsModal } from '../components/SectionVisibilityDefaultsModal';

/**
 * The module's dialog TYPES.
 *
 * Global strings carrying the module name: the registry throws on a collision
 * rather than letting whichever registered last silently win.
 *
 * Both dialogs are about a SECTION. The QUESTION editor is a page since P10.6d
 * (`/questions/new`, `/questions/:id`) — it holds the question's fields, its
 * choices and, from P10.6e/f, its visibility matrix and member-side preview,
 * which is more than a clamped dialog can carry.
 */
export const QUESTIONS_MODALS = {
  SECTION_FORM: 'questions.section-form',
  SECTION_VISIBILITY_DEFAULTS: 'questions.section-visibility-defaults',
} as const;

/**
 * The registrations `app.config.tsx` installs.
 *
 * Every payload is ids — `ModalData` is serializable-only — and the dialog loads
 * what it needs from its own query, which is what keeps an open editor correct
 * while the list refetches underneath it.
 */
export const questionsModals: readonly ModalRegistration[] = [
  { modalTypes: [QUESTIONS_MODALS.SECTION_FORM], component: SectionFormModal },
  {
    modalTypes: [QUESTIONS_MODALS.SECTION_VISIBILITY_DEFAULTS],
    component: SectionVisibilityDefaultsModal,
  },
];
